<template>
<div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
        <img class="logoNav" v-if="!isMobile()" src="../../assets/newAssets/navLogo.png" alt="">

        <b-container>
            <b-row>
                <b-col cols="12">
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                </b-col>
            </b-row>
        </b-container>

        <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="my-auto">
            <b-nav-item id="navs" @click="scrollToID('home')">HOME</b-nav-item>
            <b-nav-item id="navs" @click="scrollToID('nft')">NFT</b-nav-item>
            <b-nav-item id="navs" @click="scrollToID('aboutus')">ABOUT&nbsp;US</b-nav-item>
            <b-nav-item id="navs" @click="scrollToID('team')">TEAM</b-nav-item>
            <b-nav-item id="navs" @click="scrollToID('plan')">PLAN</b-nav-item>


            <b-icon v-if="!isMobile()" @click="redirect('twitter')" class="socialIcon twitter" font-scale="2" icon="twitter"></b-icon>
            <b-icon v-if="!isMobile()" @click="redirect('facebook')" class="socialIcon facebook" font-scale="2" icon="facebook"></b-icon>
            <b-icon v-if="!isMobile()" @click="redirect('instagram')" class="socialIcon instagram" font-scale="2" icon="instagram"></b-icon>
            <b-icon v-if="!isMobile()" @click="redirect('discord')" class="socialIcon discord" font-scale="2" icon="discord"></b-icon>

        </b-navbar-nav>

        <div v-if="isMobile()">
            <b-icon @click="redirect('twitter')" class="socialIcon twitter fullColor" font-scale="2" icon="twitter"></b-icon>
            <b-icon @click="redirect('facebook')" class="socialIcon facebook fullColor" font-scale="2" icon="facebook"></b-icon>
            <b-icon @click="redirect('instagram')" class="socialIcon instagram fullColor" font-scale="2" icon="instagram"></b-icon>
            <b-icon @click="redirect('discord')" class="socialIcon discord fullColor" font-scale="2" icon="discord"></b-icon>
            </div>
        </b-collapse>
    </b-navbar>
</div>
</template>

<script>
export default {
    mounted()
    {
        const isMobileOn = this.isMobile();
        
        $( document ).ready(function() {
            
            if(isMobileOn)
            {
                for(var i=0;i<document.getElementsByClassName("nav-link").length;i++)
                {
                    document.getElementsByClassName("nav-link")[i].style.marginLeft = 0;
                    document.getElementsByClassName("nav-link")[i].style.color = "#256ea4";
                }

                document.getElementsByClassName("twitter")[0].style.marginLeft = 0;        
                document.getElementsByClassName("socialIcon")[0].style.marginLeft = 0;
            }

            


            

            
        });
    },
    methods:{
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        scrollToID(id)
        {
            document.getElementById(id).scrollIntoView();
        },
        redirect(incoming)
        {
            if(incoming === 'twitter')
            {
                window.open(
                'https://twitter.com/VanillaHolding',
                '_blank' // <- This is what makes it open in a new window.
                );
            }
            else if(incoming === 'facebook')
            {
                window.open(
                'https://www.facebook.com/Vanilla.Holding/',
                '_blank' // <- This is what makes it open in a new window.
                );
            }
            else if(incoming === 'instagram')
            {
                window.open(
                'https://www.instagram.com/VanillaHolding/',
                '_blank' // <- This is what makes it open in a new window.
                );
            }
            else if(incoming === 'discord')
            {
                window.open(
                'https://discord.gg/hF7rVvGu3s',
                '_blank' // <- This is what makes it open in a new window.
                );
            }
        }
    }
}
</script>

<style scoped>
.navbar-toggler
{
    background-color: #256ea4;
}

.twitter
{
    
    margin-left: 2vh;
}

.logoNav
{
    height: 250px;
    position: absolute;
    left: 15%;
    top: 0%;
}
.navbar-dark .navbar-nav .nav-link
{
    font-size: 2.5vh !important;
    color: white;
    font-weight: 600;
    width: 100%;
    margin-left: 2vh;
    margin-top: 5vh;

}
.bg-dark {
    background: transparent !important;
}

.socialIcon
{
    margin-right: 2vh;
    margin-top: 5vh;
    cursor: pointer;
    color: white !important;
}

.fullColor
{
    color: #256ea4 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation/NavBar.vue